import { useEffect, useState } from 'react';
import { Spinner } from '@facephi/ui-react';
import { useApi } from '../../hooks';

type Props = {
  url: string;
  zoom?: number;
  isSmall?: boolean;
};

export const ImageViewer = ({ url, zoom, isSmall = false }: Props) => {
  const { getDocumentImage } = useApi();
  const [image, setImage] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);

  const getImage = async (url: string) => {
    const data = await getDocumentImage(url);
    setImage(data);
    setLoading(false);
  };

  useEffect(() => {
    if (url) {
      setLoading(true);
      setImage(undefined);
      getImage(url);
    }
  }, [url]);

  return !isSmall && loading ? (
    <Spinner insideComponent />
  ) : (
    <img
      src={image}
      style={{
        transform: zoom ? `translate(-50%, 0%) scale(${zoom})` : '',
      }}
    />
  );
};
